import {z} from 'zod';
import {zDateTime} from '@brunata-angular/util';

export const pictureDocSchema = z
    .object({
        docid: z.string().nullable(),
        meterid: z.string().nullable(),
        locationid: z.string().nullable(),
        dispatchorderid: z.string().nullable(),
        netunitid: z.string().nullable(),
        nopicturenote: z.string().nullable(),
        note: z.string().nullable(),
        initials: z.string(),
        timestamp: zDateTime,
        user: z.string().nullable(),
        docurl: z.string().nullish(),
    })
    .transform(it => ({
        docId: it.docid,
        meterId: it.meterid,
        locationId: it.locationid,
        dispatchOrderId: it.dispatchorderid,
        netUnitId: it.netunitid,
        noPictureNote: it.nopicturenote,
        note: it.note,
        initials: it.initials,
        timestamp: it.timestamp,
        user: it.user,
        docUrl: it.docurl,
    }));

export type PictureDocument = z.infer<typeof pictureDocSchema>;

export const pictureDocumentsSchema = z.object({
    documents: pictureDocSchema.array(),
    limited: z.boolean(),
});
